<template>
  <div class="expanded-tip-trigger" @click="showExpandedTooltip()" :name="expandedTipAnalyticsName">
      <!-- The element the tooltip should be positioned off of needs to have the ttposition attribute added to it -->
      <!-- Ex: <span ttposition>test</span> -->
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'tooltip-expanded-trigger',
  props: {
    expandedTipKey: String,
    expandedTipAnalyticsName: String
  },
  data() {
    return {
      tooltipElement: undefined
    }
  },
  mounted() {
    if (this.$slots.default[0].elm.querySelectorAll('[ttposition]').length) {
      // Store the element with the ttposition attribute as the element to use for positioning
      this.tooltipElement = this.$slots.default[0].elm.querySelectorAll('[ttposition]')[0];
    } else {
      // No element has the ttposition attribute, use the outermost element of the slot for positioning
      this.tooltipElement = this.$slots.default[0].elm;
    }
  },
  methods: {
    showExpandedTooltip() {
      let payload = {
        key: this.expandedTipKey,
        containerPosition: this.tooltipElement.getBoundingClientRect(),
        scrollDelta: window.pageYOffset
      };

      this.$store.commit('SHOW_TOOLTIP_EXPANDED', payload);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/tooltip-expanded-trigger.vue